export default __webpack_public_path__ + "static/quadrant-text-regular-18923f0fe0881b408a742de584f7692e.woff";